// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import * as z from 'zod'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_LiabilityBasicNeodigitalDe = z.object({
  zip_code: z
    .string()
    .min(1)
    .regex(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/),
  family_coverage: z.boolean(),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '150', '300']))
    .pipe(z.coerce.number()),
  number_of_claims_in_last_5y: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2']))
    .pipe(z.coerce.number()),
})

const Schema_LiabilityBasicNeodigitalDe = BaseSchema_LiabilityBasicNeodigitalDe

export default Schema_LiabilityBasicNeodigitalDe
